import React, { useEffect, useRef } from "react";

import { useStateRef } from "@/utils/hooks";

export type CounterProps = {
  start: number;
  end: number;
  duration: number;
};

export const Counter: React.FC<CounterProps> = (
  props: CounterProps
): JSX.Element => {
  const { start, end, duration } = props;
  const [count, setCount, countRef] = useStateRef<number>(start);
  const startRef = useRef<number>();
  const requestRef = useRef<number>();

  const step = (time: number) => {
    if (!startRef.current) {
      startRef.current = time;
    }
    const progress = Math.min((time - startRef.current) / duration, 1);
    const newCount = Math.floor(progress * (end - start) + start);

    if (countRef.current !== newCount) {
      setCount(newCount);
    }

    if (progress < 1) {
      // Attention: Recursion
      requestRef.current = window.requestAnimationFrame(step);
    }
  };

  useEffect(() => {
    // Animation starts after component did mount
    requestRef.current = window.requestAnimationFrame(step);
    return () => {
      // Unmount component
      if (requestRef.current) {
        window.cancelAnimationFrame(requestRef.current);
      }
    };
  }, []);

  return <React.Fragment>{count}</React.Fragment>;
};
